// extracted by mini-css-extract-plugin
export default {"container":"ItemGroup_container__52i8f","name":"ItemGroup_name__8ZgP7","small":"ItemGroup_small__ZLh2G","img":"ItemGroup_img__MyJXS"};